import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon", "folderIcon", "trigger"]
  static values = { open: { type: Boolean, default: true } }

  toggle() {
    this.openValue = !this.openValue
    this.render()
  }

  render() {
    if (this.hasContentTarget) {
      this.contentTarget.classList.toggle("hidden", !this.openValue)
    }
    if (this.hasIconTarget) {
      this.iconTarget.style.transform = this.openValue ? "rotate(0deg)" : "rotate(-90deg)"
    }
    if (this.hasFolderIconTarget) {
      this.folderIconTarget.classList.toggle("ph-folder-open", this.openValue)
      this.folderIconTarget.classList.toggle("ph-folder-simple", !this.openValue)
    }
    if (this.hasTriggerTarget) {
      this.triggerTarget.setAttribute("aria-expanded", this.openValue.toString())
    }
  }

  connect() {
    this.render()
  }
}
